var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offline-activity-qrcode"},[(_vm.uid)?_c('div',{staticClass:"qrcode",style:({ backgroundImage: ("url(" + _vm.imgUrl + ")") }),on:{"click":function () {
                if (_vm.props.clickable) {
                    _vm.dlZoom.show();
                }
            }}}):_vm._e(),_vm._v(" "),_c('DialogZoom',{ref:"dlZoom",attrs:{"src":_vm.imgUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }